export default "__VITE_ASSET__CjmTc74F__";